import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { BannerManagementComponent } from "./banner-management/banner-management";
import { PermissionAdminService } from "../../shared/services/guard-services/permission-admin.service";
import { ManagementComponent } from "./management";
import { FilterPhotoManagement } from "./filter-photo-management/filter-photo-management";
import { FilterPhotoForm } from "./filter-photo-form/filter-photo-form";
import { PopupManagement } from "./popup-management/popup-management";
import { AdvertisingManagement } from "./advertising-management/advertising-management";
import { AppManagementComponent } from "./app-management/app-management-component";
import { PointManagement } from "./point-management/point-management";

const routes: Routes = [
    {
        path: "",
        component: ManagementComponent,
        canActivate: [PermissionAdminService],
    },
    {
        path: "banner",
        component: BannerManagementComponent,
        canActivate: [PermissionAdminService],
    },
    {
        path: "point",
        component: PointManagement,
        canActivate: [PermissionAdminService],
    },
    {
        path: "popup",
        component: PopupManagement,
        canActivate: [PermissionAdminService],
    },
    {
        path: "advertising",
        component: AdvertisingManagement,
        canActivate: [PermissionAdminService],
    },
    {
        path: "filter",
        component: FilterPhotoManagement,
        canActivate: [PermissionAdminService],
    },
    {
        path: "filter-form",
        component: FilterPhotoForm,
        canActivate: [PermissionAdminService],
    },
    {
        path: "app",
        component: AppManagementComponent,
        canActivate: [PermissionAdminService],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [PermissionAdminService],
})
export class AdministratorRoutingModule {}
